import { Stack, XStack, YStack, YStackProps } from '@mythical/ui'
import { Check } from '@tamagui/lucide-icons'
import { SizableText } from 'tamagui'

export interface PerksListProps extends YStackProps {
  perkTitles: string[]
  disabled?: boolean
}

export const PerksList = ({
  perkTitles,
  disabled,
  ...props
}: PerksListProps) => (
  <YStack gap="$3.5" px="$3.5" opacity={disabled ? 0.5 : 1} {...props}>
    {perkTitles.map((perk) => (
      <XStack key={perk} ai="flex-start" gap="$3.5">
        <Stack ai="center" w={16} h={16}>
          <Check col="$fgPrimary" />
        </Stack>
        <SizableText size="$3" fontWeight="500">
          {perk}
        </SizableText>
      </XStack>
    ))}
  </YStack>
)
